import { useSyncExternalStore } from "react";

let rotationGizmoVisible = false;
const listeners = new Set();

const emit = () => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      // ignore listener failures
    }
  });
};

const dispatchSceneEvent = (visible) => {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(new CustomEvent("rotation-gizmo-visibility", { detail: { visible } }));
  } catch {
    // ignore
  }
};

export const getRotationGizmoVisible = () => rotationGizmoVisible;

export const setRotationGizmoVisible = (nextVisible) => {
  const next = !!nextVisible;
  if (rotationGizmoVisible === next) return next;
  rotationGizmoVisible = next;
  dispatchSceneEvent(next);
  emit();
  return next;
};

export const toggleRotationGizmoVisible = () => setRotationGizmoVisible(!rotationGizmoVisible);

export const subscribeRotationGizmoVisible = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useRotationGizmoVisibility = () => {
  const visible = useSyncExternalStore(
    subscribeRotationGizmoVisible,
    getRotationGizmoVisible,
    getRotationGizmoVisible
  );
  return [visible, setRotationGizmoVisible];
};
